import api from "./api";
import { WorkoutPlanPayload, WorkoutPlanFeedback } from "../types";

async function update_plan(plans_id: string, body: WorkoutPlanPayload) {
  try {
    await api.put(`/workout-plans/${plans_id}/`, body);
    return true;
  } catch (e) {
    console.error("Erro ao atualizar plano:", e);
    return false;
  }
}

async function create_plan(body: WorkoutPlanPayload) {
  try {
    await api.post(`/workout-plans/`, body);
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
}

async function delete_plan(plans_id: string) {
  try {
    await api.delete(`/workout-plans/${plans_id}/`);
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
}

async function listAll(professional_id: string, user_id: string) {
  try {
    const { data } = await api.get(
      `/workout-plans/${professional_id}/${user_id}/`
    );
    return data;
  } catch (e) {
    return [];
  }
}

async function listFeedbacksByUser(
  user_id: string
): Promise<WorkoutPlanFeedback[]> {
  try {
    const { data } = await api.get(
      `/workout-plans/feedbacks/${user_id}/`
    );
    return data;
  } catch (e) {
    return [];
  }
}

const workoutplans = {
  update_plan,
  delete_plan,
  create_plan,
  listAll,
  listFeedbacksByUser,
};

export default workoutplans;
